import React from "react";
import second from "../images/second.mp4";
import first from "../images/first.mp4";

export const Videos = () => {
  return (
    <div id="features" className="text-center">
      <div className="container" style={{ marginBottom: "100px" }}>
        <div
          className="col-md-10 col-md-offset-1 section-title"
          style={{ marginTop: "20px" }}
        >
          <h2>Videos</h2>
        </div>

        <div className="row">
          <div className="col-sm-6 col-md-6 text-center">
            <video
              src={second}
              className="center-block platform-img"
              autoPlay
              muted
              loop
              playsInline
              style={{ width: "400px", height: "500px", maxWidth: "400px", objectFit: "cover" }}
            />
          </div>

          <div className="col-sm-6 col-md-6 text-center">
            <video
              src={first}
              className="center-block platform-img"
              autoPlay
              muted
              loop
              playsInline
              style={{ width: "400px", height: "500px", maxWidth: "400px", objectFit: "cover" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
